var React = require('react');

function ContentWifiAlt (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m650.3,131.6C565.6,46.9,452.9,0,332.5,0S99.4,46.9,14.7,131.6c-19.6,19.6-19.6,50.4,0,70,9.8,9.8,22.4,14.7,35,14.7s25.2-4.9,35-14.7c65.8-66.5,154-102.9,247.8-102.9s182,36.4,247.8,102.9c19.6,19.6,50.4,19.6,70,0,19.6-19.6,19.6-51.1,0-70Z","key":0}),React.createElement("path",{"d":"m146.3,263.9c-19.6,19.6-19.6,50.4,0,70,9.8,9.8,22.4,14.7,35,14.7s25.2-4.9,35-14.7c64.4-64.4,168.7-64.4,232.4-.7,18.9,19.6,50.4,19.6,70,0s19.6-50.4,0-70c-102.9-102.2-269.5-102.2-372.4.7h0Z","key":1}),React.createElement("path",{"d":"m410.2,449.4c0,42.53-34.47,77-77,77s-77-34.47-77-77,34.48-77,77-77,77,34.48,77,77","key":2})]);
}

ContentWifiAlt.defaultProps = {"role":"presentation","data-name":"Layer 1","width":"665","height":"526.4","viewBox":"0 0 665 526.4"};

module.exports = ContentWifiAlt;

ContentWifiAlt.default = ContentWifiAlt;
